import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const Hongbao = Loadable({
    loader: () => import(/* webpackChunkName: "Hongbao" */ './hongbao'),
    loading: () => <div />,
});
